'use strict';

const { waitOnEvent } = require('./event-helper');
const { publish } = require('./event-observer');

function handleEvent(event) {
  if (
    event.type === 'click' &&
    Array.isArray(event.widgets) &&
    event.widgets.length &&
    (event.widgets[0].type === 'coupon' ||
      event.widgets[0].type === 'direct-link')
  ) {
    event.originalEvent.preventDefault();

    const element = event.widgets[0];
    const isRedirect = element.path.includes('redirect');
    const { type } = element.metadata || {};
    const isMerchant = element.type === 'direct-link';

    publish('EVENT_ID', {
      eventId: event.id,
      type,
      isRedirect,
      isMerchant,
    });
  }
}

window.onload = function () {
  waitOnEvent({
    doneCheck: () =>
      !!window.OptimizeSuite && !!window.OptimizeSuite.bloodhound,
    callback: () => window.OptimizeSuite.bloodhound.on('event', handleEvent),
    fallback: handleEvent,
  });
};
